import * as a from '../actions'
import userEventUpdate, { initialState as userEventInitialState } from './user_events'

const initialState = {
  auth: {
    access_token: null,
  },
  id: null,
  team: {
    name: null,
  },
  level: null,
  credits: 0,
  experience: 0,
  medals: [],
  selectedMedal: {
    id: null,
    description: '',
    name: '',
    image_url: '',
    credits: 0,
  },
  selectedMission: {
    id: null,
    description: '',
    name: '',
    credits: 0,
    experience: 0,
  },
  selectedTitle: {
    id: null,
    description: '',
    name: '',
    credits: 0,
    experience: 0,
  },
  missions: [],
  people_log: [],
  global_prizes: {
    prizes: [],
    prize_selected: {
      id: null,
      credits: 0,
      experience: 0,
      amount: 0,
    },
  },
  titles: [],
  my_prizes: [],
  title: {
    id: null,
  },
  userEvents: userEventInitialState,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case a.USER_LOGGED_IN:
      return { ...state, ...payload, auth: { access_token: payload.access_token } }
    case a.USER_LOGGED_OUT:
      return initialState
    case a.UPDATE_PROFILE_SUCCEEDED:
      return { ...state, ...payload }
    case a.USER_LOGIN_ERROR:
      return initialState
    case a.USER_INFO_FETCH_SUCCEEDED:
      return { ...state, ...payload }
    case a.NEW_EVENTS_FETCH_SUCCEEDED:
      return { ...state,
        userEvents: userEventUpdate(
          state.userEvents,
          { type, payload },
        ),
      }
    case a.USER_INFO_FETCH_FAILED:
      return initialState
    case a.EDIT_PROFILE_INFO_SUCCEEDED:
      return { ...state, ...payload }
    case a.EDIT_PROFILE_INFO_FAILED:
      return initialState
    case a.PEOPLE_LOG_FETCH_SUCCEEDED:
      return { ...state, people_log: payload }
    case a.PEOPLE_LOG_FETCH_FAILED:
      return state
    case a.PRIZES_FETCH_SUCCEEDED:
      return { ...state, global_prizes: { ...state.global_prizes, ...payload } }
    case a.PRIZES_FETCH_FAILED:
      return state
    case a.PRIZE_SELECTED:
      return { ...state, global_prizes: { ...state.global_prizes, prize_selected: payload } }
    case a.PRIZE_DESELECTED:
      return { ...state, global_prizes: { ...state.global_prizes, prize_selected: null } }
    case a.OWN_PRIZES_FETCH_SUCCEEDED:
      return { ...state, my_prizes: payload }
    case a.BUY_PRIZE_SUCCEEDED:
      const prizes = state.global_prizes.prizes.map((prize) => {
        if (prize.id === payload.id) { prize.amount -= 1 }
        return prize
      })
      const prize_selected = state.global_prizes.prize_selected
      if (prize_selected && prize_selected.id === payload.id) { prize_selected.amount -= 1 }
      return { ...state,
        my_prizes: [payload, ...state.my_prizes],
        credits: state.credits - payload.credits,
        global_prizes: {
          prize_selected,
          prizes,
        },
        userEvents: userEventUpdate(
          state.userEvents,
          { type, payload },
        ),
      }
    case a.SELECT_MEDAL:
      return { ...state,
        selectedMedal: state.medals.find(x => x.id === payload.id) }
    case a.SELECT_MISSION_SUCCEEDED:
      return { ...state,
        selectedMission: payload }
    case a.SELECT_MISSION_FAILED:
      return { ...state }
    case a.SELECT_ACTIVITY_MEDAL:
      return { ...state,
        selectedMedal: payload.medal }
    case a.SELECT_ACTIVITY_MISSION:
      return { ...state,
        selectedMission: payload.mission }
    case a.SELECT_ACTIVITY_TITLE:
      return { ...state,
        selectedTitle: payload.title }
    case a.EVENT_ALERT_SHOWED:
      return {
        ...state,
        userEvents: userEventUpdate(state.userEvents, { type, payload }),
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.jsx